import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Card, Container, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import GridToSettingPlant from '../../components/grid/GridToSettingPlant'
import Factory from '../../assets/img/factory.png'
import MasterFooter from "../../components/setting/MasterFooter"


const setting_title = [
    {
        title: '4045',
        detail: 'Setting master std in plant 4045',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4071',
        detail: 'Setting master std in plant 4071',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4116',
        detail: 'Setting master std in plant 4116',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4117',
        detail: 'Setting master std in plant 4117',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: 'B425',
        detail: 'Setting master std in plant B425',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4003',
        detail: 'Setting master std in plant 4003',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4087',
        detail: 'Setting master std in plant 4087',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
    {
        title: '4179',
        detail: 'Setting master std in plant 4179',
        icon: <img src={Factory} height="60vh" />,
        click: 'master-std-factory'
    },
]

setting_title.sort((a, b) =>
  a.title.localeCompare(b.title, undefined, { numeric: true })
);





export default function MasterSTDPlant() {
    const navigate = useNavigate();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    function storeCourse(name) {
        sessionStorage.setItem('master_std_plant', name)
    }


    return (

        <Box sx={{
            width: "100%",
            height: "93.5vh",
            position: "relative", 
            overflow: "hidden",
        }}>
            <Helmet>
                <title>STD Plant | MES</title>
            </Helmet>
            <Container maxWidth="md">
                <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }}>
                    <Typography style={{ color: colors.neutral['black'], fontSize: 58, fontWeight: 'bold' }} >
                        Plant
                    </Typography>
                </Grid>


                <Grid item xs={10} style={{ paddingTop: 30 }} textAlign="center">
                    <Grid container rowSpacing={4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} >
                        {setting_title.map((item) => {
                            return (
                                <Grid item xs={4} onClick={() => { navigate(`/${item.click}`, { replace: true }); storeCourse(item.title) }}>
                                    <GridToSettingPlant
                                        icon={item.icon}
                                        title={item.title}
                                        detail={item.detail}
                                        onClick={() => storeCourse(item.title)}
                                    />
                                </Grid>
                            )
                        })
                        }
                    </Grid>
                </Grid>
            </Container>
            <Box
                sx={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    zIndex: 10, 
                }}
            >
                <MasterFooter click={'setting'} />
            </Box>
        </Box>
    );
}






